import Reveal from '../components/animation/Reveal';
import PageFrame from '../components/layout/PageFrame';
import { businessDetails } from '../data/siteContent';

function PrivacyPage() {
  return (
    <PageFrame title="Privacy Policy" eyebrow="Customer information">
      <Reveal className="policy-content">
        <p>
          Saqar Al-Jazeera uses this website as an internal reference for the owner and team. It is not a public booking platform, but contact and order details may still be handled during normal tailoring work.
        </p>
        <h2>Information we collect</h2>
        <p>We may keep basic customer details such as name, phone number, garment type, measurements, fitting notes, fabric preference, delivery timeline, and branch-related order notes.</p>
        <h2>Why we keep it</h2>
        <p>These details help the team prepare accurate dishdasha stitching, repeat past measurements, manage alterations, coordinate branch communication, and avoid mistakes in future orders.</p>
        <h2>How we use information</h2>
        <p>Information is used only for tailoring operations, owner follow-up, pricing conversations, order preparation, fitting corrections, and customer service through phone or WhatsApp.</p>
        <h2>Data care</h2>
        <p>Customer information should be shared only with people involved in the tailoring work. We do not sell personal information or use it for unrelated marketing.</p>
        <h2>Retention</h2>
        <p>Measurement and order notes may be kept as long as they are useful for repeat tailoring or alteration history. Details that are no longer needed should be corrected or removed on request.</p>
        <h2>Third-party links</h2>
        <p>The website includes links to WhatsApp, Instagram, and TikTok. Those services have their own privacy practices when you open or message through them.</p>
        <h2>Contact</h2>
        <p>For privacy questions or correction requests, please contact {businessDetails.manager} at {businessDetails.phone}.</p>
      </Reveal>
    </PageFrame>
  );
}

export default PrivacyPage;
